/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Public_Not_Found_DescriptionInputs */



/**
* | output |
* | --- |
* | "This artifact does not exist or is no longer publicly shared." |
*
* @param {Artifact_Public_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_public_not_found_description = /** @type {((inputs?: Artifact_Public_Not_Found_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Public_Not_Found_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Artefakt existiert nicht oder ist nicht mehr öffentlich geteilt.")
	return /** @type {LocalizedString} */ ("This artifact does not exist or is no longer publicly shared.")
});